import React, { useState } from "react";
import SideNavigation from "../../components/dumb/projectManager/SideNavigation";
import { useSelector } from "react-redux";
import useStatusThunk from "../../hook/useStatusThunk";
import useEffectWithoutLoad from "../../hook/useEffectWithoutLoad";
import useAuthEffect from "../../hook/useAuthEffect";
import RouteHeader from "../../components/dumb/RouteHeader";
import { fetchAnalysis } from "../../redux/ducks/analysis";
import { mapData } from "../../helpers/mapRow";
import Analysis from "../../components/dumb/tables/Analysis";

const AnalysisRoute = ({ match }) => {

    const analysisID = match.params.analysisID;

    const analysis = useSelector(state => state.analysis.analyses[analysisID]);
    const [dispatchFetchAnalysis, status, error] = useStatusThunk(fetchAnalysis);
    const [rows, setRows] = useState([]);

    useAuthEffect(isAuth => dispatchFetchAnalysis({ analysisID }));

    useEffectWithoutLoad(() => {
        if (status == "success") setRows(mapData(analysis?.rows));
    }, [status, analysis?.rows]);

    return (
        <div className="columns-container">
            <div className="column column--sidenav">
                <SideNavigation selected="analyses" />
            </div>

            <div className="column column--primary">
                <RouteHeader title={`${analysis?.name}`} data={{ "ID": analysisID, "Task IDs": analysis?.tasks, "Created By": analysis?.createdBy, "Created": analysis?.created }} />
                <Analysis rows={rows} tasks={analysis?.tasks}/>
            </div>
        </div >
    )
}

export default AnalysisRoute;